export default {
  TOGGLE_MENU: 'toggleMenu',
  TOGGLE_DIRECTION: 'toggleDirection',
  CHANGE_CURSOR_STATE: 'changeCursorState',
  GET_VIEWPORT_DIMENSIONS: 'getViewportDimensions',
  SET_CURRENT_PREVIEW: 'setPreviewIndex',
  SET_DID_SEE_INTRO_ANIM: 'setDidSeeIntroAnim',
  SET_DID_SHOW_SELECTOR_PRESENTER: 'setDidShowSelectorPresenter',
  SET_DID_WATCH_INTRO_ANIM_IN_SECTION: 'setDidWatchIntroAnimInSection',
  SET_TOGGLE_CONTACT_MODAL_OPEN: 'setToggleContactModalOpen',
  SET_DID_SEE_DRAG_TOOLTIP: 'setDidSeeDragTooltip'
}
